// src/app/shared/auth/keycloak/logout-service/logout.token.ts
import { InjectionToken } from '@angular/core';
import { ILogoutService } from '@app/shared/auth/logout/logout-service';

export const LOGOUT = new InjectionToken<ILogoutService>('ILogoutService');
